import React, {useEffect, useState, useContext} from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { Scrollbar } from 'react-scrollbars-custom';
import userlogo from "./../../../Public/img/avatar-14.jpg";
import { AuthContext } from "../../../context/AuthContext";
//import jQuery from 'jquery';
//import 'jquery-slimscroll';
//import SlimScroll from "react-jquery-slimscroll";



const Sidebar = () =>{
    const navigate = useNavigate();
    const currenturl = useLocation();
    const {user, setUser} = useContext(AuthContext);

    const [loggedname, setLoggedName] = useState("");
    const [loggedroleid, setLoggedRoleID] = useState(0);
    const [loggedemail, setLoggedEmail] = useState("");

    const scrollstyle = {
                        height: 'auto',
                        width: '100%',
                        position: 'right',
                        size: '7px',
                        color: '#ccc',
                        wheelStep: 10,
                        touchScrollStep: 100,
                        };


    useEffect(() =>{

        //init();
		
        var $slimScrolls = $('.slimscroll');
        
        if($slimScrolls.length > 0) {
            
            var wHeight = $(window).height() - 60;
            $slimScrolls.height(wHeight);
            $('.sidebar .slimScrollDiv').height(wHeight);
            $(window).resize(function() {
                var rHeight = $(window).height() - 60;
                $slimScrolls.height(rHeight);
                $('.sidebar .slimScrollDiv').height(rHeight);
            });
        }
		

            $(document).on('mouseover', function(e) {
                e.stopPropagation();
                if ($('body').hasClass('mini-sidebar') && $('#toggle_btn').is(':visible')) {
                    var targ = $(e.target).closest('.sidebar, .header-left').length;
                    if (targ) {
                        $('body').addClass('expand-menu');
                        $('.subdrop + ul').slideDown();
                    } else {
                        $('body').removeClass('expand-menu');
                        $('.subdrop + ul').slideUp();
                    }
                    return false;
                }
            });

            if($('#btnFullscreen').length > 0) {
                document.getElementById('btnFullscreen').addEventListener('click', function() {
                    toggleFullscreen();
                });
            }
        //SlimScroll($);
        
        
        const userinfo = localStorage.getItem("userinfo");

        if(userinfo !== "" && userinfo !== null && userinfo !== undefined)
        {
            const loggeduserdata = JSON.parse(userinfo);

            setLoggedName(loggeduserdata.name);
            setLoggedRoleID(loggeduserdata.role_id);
            setLoggedEmail(loggeduserdata.email);
            //console.log('User info===='+loggeduserdata);
            //console.log('User info===='+loggeduserdata.name);
        }

    }, []);

    const toggleFullscreen = () =>{
		if (!document.fullscreenElement) 
		{
			document.documentElement.requestFullscreen();
		} 
		else 
		{
			if (document.exitFullscreen) 
			{
				document.exitFullscreen();
			}
		}
	}

    const handleSignout = () =>{
        //localStorage.removeItem('cpmstoken');
        sessionStorage.removeItem('cpmstoken');
        localStorage.removeItem('userinfo');

        setUser(null);

        navigate('/sign-in', { replace: true });
    }

    return(
        <div className="sidebar" id="sidebar">
			
			<div className="sidebar-inner slimscroll">
                <Scrollbar style={scrollstyle}>
                    <div id="sidebar-menu" className="sidebar-menu">
                        <ul>
                            <li className="clinicdropdown">
                                <div className="profile-data">
                                    <img src={userlogo} className="img-fluid" alt="Profile" />
                                    <div className="user-names">
                                        <h5>{loggedname}</h5>
                                        <h6>Publisher</h6>
                                        
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <h6 className="submenu-hdr">Main Menu</h6>
                                <ul>
                                    <li>
                                        <Link to="/publisher/dashboard" className={currenturl.pathname === '/publisher/dashboard' ? 'active' : ''}>
                                            <i className="ti ti-home"></i>
                                            <span>Dashboard</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/publisher/leads" className={currenturl.pathname === '/publisher/leads' ? 'active' : ''}>
                                            <i className="ti ti-location"></i>
                                            <span>Leads</span>
                                        </Link>
                                    </li>
                                                                        
                                    <li>
                                        <div onClick={handleSignout}>
                                            <i className="ti ti-power"></i>
                                            <span>Logout</span>
                                        </div>
                                    </li>                                   
                                </ul>
                            </li>

                            
                        </ul>
                    </div>
                </Scrollbar>
			</div>
		</div>
    )
}

export default Sidebar;